import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Lottie } from "../../constant/lottie";
import { contentOfConfirmationCard } from "../../constant/content";
import { GtmService } from "../../services/gtm-service/gtm.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
    selector: "web-confirmation-card",
    templateUrl: "./confirmation-card.component.html",
    styleUrls: ["./confirmation-card.component.scss"],
})
export class ConfirmationCardComponent {
    content: any;
    lottie: any;
    private popupName: string = "confirmation_dialog";
    contentDescription!: SafeHtml;

    constructor(
        public lotties: Lottie,
        private gtmService: GtmService,
        public dialogRef: MatDialogRef<ConfirmationCardComponent>,
        private sanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.lottie = this.lotties;

        // Check if object passed or just key
        if (data?.content && typeof data.content === "object") {
            this.content = { ...data.content };
        } else {
            this.content = contentOfConfirmationCard[data?.content] || {};
        }
    }

    ngOnInit(): void {
        // Track popup opened
        this.gtmService.trackPopupOpened(this.popupName, {
            popup_content: this.data?.content || "confirmation",
            popup_title: this.content?.title || null,
            popup_trigger: "user_action",
        });

        if (this.content?.html && this.content?.description) {
            this.contentDescription = this.sanitizer.bypassSecurityTrustHtml(this.content.description);
        }
    }

    onConfirmClick(): void {
        // Track popup closed with confirm action
        this.gtmService.trackPopupClosed(this.popupName, {
            close_reason: "user_action",
            interaction_type: "confirm",
        });

        this.dialogRef.close({ confirmed: true, data: this.data });
    }

    onCancelClick(): void {
        // Track popup closed with cancel action
        this.gtmService.trackPopupClosed(this.popupName, {
            close_reason: "user_action",
            interaction_type: "cancel",
        });

        this.dialogRef.close({ confirmed: false, data: this.data });
    }
}
